import {Component, forwardRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import {errorMessages} from '../../core/errors/error-messages';
import * as _ from 'lodash';
import {LookupModel} from '../../api/models/lookup-model';
import { FlexModule } from '@angular/flex-layout';
import { MatSimpleSelectComponent } from '../mat-simple-select/mat-simple-select.component';

@Component({
    selector: 'app-duration-input',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DurationInputComponent),
            multi: true
        }
    ],
    template: `
    <div class="form-group" style="margin-bottom: 0">
      <label style="display: block;" [for]="_id">{{label}}</label>
      <div fxLayout="row" fxLayoutGap="5px">
        <app-mat-simple-select [(ngModel)]="hour" label="Hour" (ngModelChange)="onHourChange($event)" [selectItems]="hours"
                               style="min-width: 70px">
        </app-mat-simple-select>
        <app-mat-simple-select [(ngModel)]="minute" label="Minute" (ngModelChange)="onMinuteChange($event)" [selectItems]="minutes"
                               style="min-width: 70px">
        </app-mat-simple-select>
        <app-mat-simple-select [(ngModel)]="second" label="Second" (ngModelChange)="onSecondChange($event)" [selectItems]="seconds"
                               style="min-width: 80px">
        </app-mat-simple-select>
      </div>
    </div>`,
    styles: [],
    standalone: true,
    imports: [FlexModule, MatSimpleSelectComponent, FormsModule]
})
export class DurationInputComponent implements ControlValueAccessor, OnChanges {

  value: any;
  isDisabled: boolean;
  firstFormError: any;
  _id: string;

  hours: LookupModel[];
  minutes: LookupModel[];
  seconds: LookupModel[];

  hour = 0;
  minute = 0;
  second = 0;

  @Input() label: string;
  @Input() name: string;
  @Input() id: string;
  @Input() submitted: boolean;
  @Input() infoText: string;
  @Input() formValidators: any[];
  @Input() formControl: UntypedFormControl;

  @Input() dataList: any[];

  @Input() filterable: boolean;

  constructor() {
    this.setId();
    this.hours = Array(7).fill(0).map((x, i) => {
      return {id: i, text: i.toString()};
    });
    this.minutes = Array(60).fill(0).map((x, i) => {
      return {id: i, text: i.toString()};
    });
    this.seconds = Array(60).fill(0).map((x, i) => {
      return {id: i, text: i.toString()};
    });
  }

  @Input() filterChange = (a: any) => {
  };

  propagateChange = (a: any) => {
  };

  onTouched = (a?: any) => {
  };

  ngOnChanges(changes: SimpleChanges): void {

  }

  setId(): void {
    if (this.id) {
      this._id = this.id;
    }
    if (this.name) {
      this._id = this._id = _.uniqueId(`${this.name}_`);
    }

    this._id = _.uniqueId('id_');
  }

  showErrors() {
    return (!this.isValid() && this.isDirty()) || (this.submitted && !this.isValid() || this.hasFormError());
  }

  isUnTouched() {
    return !!(this.formControl && this.formControl.untouched);
  }

  isValid() {
    return !!(this.formControl && this.formControl.valid);
  }

  isDirty() {
    return !!(this.formControl && this.formControl.dirty);
  }

  hasFormError() {
    const formErrors = this.formControl?.parent?.errors;

    if (this.formValidators) {

      for (const error in formErrors) {
        if (formErrors.hasOwnProperty(error)) {
          this.firstFormError = this.formValidators.find((item) => {
            return item.key === error;
          });

          if (this.firstFormError) {
            return true;
          }
        }
      }
    }
    return false;
  }

  firstError(): string | undefined {

    if (this.hasFormError()) {
      return this.firstFormError.error;
    }

    if (this.formControl && this.formControl.errors) {
      for (const error in this.formControl.errors) {
        if (this.formControl.errors.hasOwnProperty(error)) {

          // get error description
          let message = errorMessages[error];
          if (!message) {
            message = `Unknown error: ${error}`;
          }
          return message;
        }
      }
    }

    return undefined;
  }

  errors(): string[] {
    const errorsMessages: string[] = [];
    if (this.formControl && this.formControl.errors) {
      for (const error in this.formControl.errors) {
        if (this.formControl.errors.hasOwnProperty(error)) {

          // get error description
          const message = errorMessages[error];
          if (message) {
            errorsMessages.push(message);
          } else {
            errorsMessages.push(`Unknown error: ${error}`);
          }
          console.log(error);
        }
      }
    }

    return errorsMessages;
  }

  writeValue(obj: number): void {
    this.value = obj || 0;

    this.hour = Math.floor(this.value / 3600);
    this.minute = Math.floor((this.value - (this.hour * 3600)) / 60);
    this.second = Math.round(this.value - (this.hour * 3600) - (this.minute * 60));
  }

  onChange(event) {
    this.onTouched();

    const totalSeconds = this.hour * 3600 + this.minute * 60 + this.second;
    console.log(totalSeconds);
    this.propagateChange(totalSeconds);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onHourChange(event) {
    this.hour = event;
    this.onChange(event);
  }

  onMinuteChange(event) {
    this.minute = event;
    this.onChange(event);
  }

  onSecondChange(event) {
    this.second = event;
    this.onChange(event);
  }
}
